import { render, staticRenderFns } from "./canpaigns-infos.vue?vue&type=template&id=c83a9392&scoped=true"
import script from "./canpaigns-infos.vue?vue&type=script&lang=js"
export * from "./canpaigns-infos.vue?vue&type=script&lang=js"
import style0 from "./canpaigns-infos.vue?vue&type=style&index=0&id=c83a9392&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c83a9392",
  null
  
)

export default component.exports